var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brochure-page"},[_c('div',{staticClass:"wallpapers-container masonry-container"},_vm._l((_vm.brochures),function(brochure,index){return _c('BrochureCard',{key:'brochure-' + index,staticClass:"masonry-item",attrs:{"brochure":brochure}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }